module.exports = __webpack_public_path__ + "img/1127.c010b97c.gif";